/**
 * This file is auto generated via npm run generate.resolved-outline
 */
export default {
  destBasePath: 'dist',
  components: { bundle: ['outline', 'utility'] },
  assets: {
    dir: ['src/assets/svg', 'src/assets/video'],
    sync: ['dist/assets', 'src/.storybook/static/dist/assets'],
  },
  fonts: {
    dir: ['../themes/outline_frontend/assets/fonts'],
    sync: [
      'dist/themes/custom/outline_frontend/assets',
      'src/.storybook/static/themes/custom/outline_frontend/assets',
    ],
  },
  screens: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1440px',
    xxxl: '2160px',
  },
  css: {
    global: [
      { src: 'src/shared.css', dest: 'dist/shared.css' },
      { src: 'outlineBH.theme.css', dest: 'dist/outlineBH.theme.css' },
      { src: 'outline.theme.css', dest: 'dist/outline.theme.css' },
      { src: 'src/.storybook/tailwind.css', dest: 'dist/tailwind.css' },
      { src: 'src/.storybook/storybook.css', dest: 'dist/storybook.css' },
      { src: 'src/static.css', dest: 'dist/static.css' },
      { src: 'src/wysiwyg.css', dest: 'dist/wysiwyg.css' },
      { src: 'src/wysiwyg-ckeditor5.css', dest: 'dist/wysiwyg-ckeditor5.css' },
    ],
    fouc: { enabled: true, dest: 'dist/fouc.css' },
  },
  js: { output: { lazy: true, full: true, data: false } },
  color: { sets: ['outline', 'primary', 'secondary', 'tertiary', 'neutral'] },
  icons: {
    libraries: {
      bootstrap: true,
      boxicons: true,
      fontawesome: true,
      heroicons: true,
      iconoir: true,
      ionicons: true,
      jam: true,
      lucide: true,
      material: true,
      remix: true,
      unicons: true,
    },
    defaults: { library: 'bootstrap', size: '16px', icon: 'chevron-right' },
  },
  youtube: { defaultVideo: 'xiqgG8HUZXE' },
  vimeo: { defaultVideo: '432639001' },
  excludedStories: [
    'outline-button',
    'outline-card',
    'outline-accordion',
    'outline-icon',
    'outline-dropdown',
    'outline-list',
    'outline-icon',
    'outline-admin-links',
    'outline-breadcrumbs',
    'outline-link',
    'outline-tab',
    'outline-alert',
    'outline-modal',
    'outline-code-block',
    'outline-swatch',
    'outline-swatch-set',
  ],
  splide: { keyboard: false, arrows: true },
};
